import SystemDashboard from '@/models/SystemDashboard'
import LeadershipDashboardModule from './views/LeadershipDashboardModule'
import OverviewDashboardModule from './views/OverviewDashboardModule'
import WeeklySalesDashboardModule from './views/WeeklySalesDashboardModule'
import SalesManagementDashboardModule from './views/SalesManagementDashboardModule'
import SalesActivityDashboardModule from './views/SalesActivityDashboardModule'
import HamiltonOverviewModule from './views/HamiltonOverviewModule'
import MLBModule from './views/MLBModule'
import ActiveInternationalModule from './views/ActiveInternationalModule'
import CIMWorkloadModule from './views/CIMWorkloadModule'
import SalesDashboardModule from './views/SalesDashboardModule'
import SSLOrderAnalysis from './views/SSLOrderAnalysis'
import MarquetingRequestModule from './views/MarketingRequestModule'
import MediaKPIModule from './views/MediaKPIModule'
import SLTDashboardModule from './views/SLTDashboardModule'
import SLTQTRModule from './views/SLTQTR'
import DisneyModule from './views/DisneyModule'
import DeliveryModule from './views/DeliveryModule'

// const user = getModule(SystemtModule).user

const dashboards: SystemDashboard[] = [
  new SLTDashboardModule(),
  new SLTQTRModule(),
  new LeadershipDashboardModule(),
  new OverviewDashboardModule(),
  new SalesDashboardModule(),
  new SalesManagementDashboardModule(),
  new WeeklySalesDashboardModule(),
  new SalesActivityDashboardModule(),
  new HamiltonOverviewModule(),
  new MLBModule(),
  // Same company as MLB, but with a goal picker for switching between multiple
  // active distribution goals. Rename title/key as needed.
  new MLBModule({
    key: 'mlb_multigoal_dashboard',
    title: 'MLB Home Teams',
    show_goal_picker: true,
  }),
  new DisneyModule(),
  new DeliveryModule(),
  new MLBModule({
    filters: {
      company_id: '96ed6c23-1824-4aa8-bfb6-10b1c98473c8',
    },
    key: 'directv_dashboard',
    title: 'DirecTV',
    logo: '/images/directv.logo.png',
    show_logo_on_export: true,
  }),
  new MLBModule({
    filters: {
      company_id: 'a04afc5d-b3fc-4575-a87d-99a51ecffb5e',
    },
    key: 'victory_plus_dashboard',
    title: 'Victory+',
    logo: '/images/ducks.logo.svg',
    show_logo_on_export: true,
    hide_goal_tracker: true,
  }),
  new ActiveInternationalModule(),
  new MarquetingRequestModule(),
  new CIMWorkloadModule(),
  new SSLOrderAnalysis(),
  new MediaKPIModule(),
]

export default dashboards
